import { DocumentRevisionStatus, type DocumentType } from '@/shared/lib';
import { formatDocumentRevisionStatus, formatStatusForDocumentType } from '@/shared/lib/utils';
import { isExternalDocument } from './externalDocument';
import type { DocumentRevision } from '../model/types';

const REVOKED_LABEL = 'Revogado';

function isRevokedExternalDocument(revision: DocumentRevision): boolean {
  return revision.status === DocumentRevisionStatus.OBSOLETE && isExternalDocument(revision);
}

export function getDocumentRevisionStatusLabel(revision: DocumentRevision): string {
  if (isRevokedExternalDocument(revision)) {
    return REVOKED_LABEL;
  }

  return formatDocumentRevisionStatus(revision.status);
}

export function getDocumentRevisionStatusLabelForType(
  revision: DocumentRevision,
  documentType: DocumentType,
  fallback: string = ''
): string {
  if (isRevokedExternalDocument(revision)) {
    return REVOKED_LABEL;
  }

  return formatStatusForDocumentType(revision.status, documentType, fallback);
}
